export default __webpack_public_path__ + "ae4e6a04622f52b6ab33f36026169299.svg";